import React from "react";
import { Box, SimpleGrid, Text, useColorModeValue, Icon } from "@chakra-ui/react";
import { MdEventAvailable, MdAccessTime, MdTableChart, MdAttachMoney } from "react-icons/md";
import { FaEuroSign } from "react-icons/fa";

const statsConfig = [
  {
    key: "OrdersToday",
    label: "Orders Today",
    icon: MdEventAvailable,
  },
  {
    key: "DeliveriesToday",
    label: "Deliveries Today",
    icon: MdAccessTime,
  },
  {
    key: "OrderCount",
    label: "Order Count",
    icon: MdTableChart,
  },
  {
    key: "OrderAmount",
    label: "Order Amount",
    icon: FaEuroSign,
  },
];

const StatsCards = ({ stats }) => {
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const brandColor = useColorModeValue("#3c31ce", "white");

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }} gap="20px" mb="20px">
      {statsConfig.map(({ key, label, icon: StatIcon }) => (
        <Box
          key={key}
          bg={boxBg}
          borderRadius="xl"
          p={6}
          display="flex"
          alignItems="center"
          boxShadow="lg"
          border={"1px blue solid"}
        >
          <Box
            w="56px"
            h="56px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg={brandColor}
            borderRadius="full"
            mr={4}
          >
            <Icon as={StatIcon} w="32px" h="32px" color="white" />
          </Box>
          <Box>
            <Text fontSize="xl" fontWeight="bold">
              {stats[key] ?? 0}
            </Text>
            <Text fontSize="md" color="gray.500">
              {label}
            </Text>
          </Box>
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default StatsCards;
